var _path, _rect, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenLinesDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 447,
    height: 503,
    viewBox: "0 0 447 503",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167 58.002L129 16.002L22 126.502L129 241.002L167 199.002L98.5 126.502L167 58.002Z",
    stroke: "url(#paint0_linear_1659_35)",
    strokeWidth: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.5711,
    y: 257.807,
    width: 47,
    height: 47,
    transform: "rotate(-45 39.5711 257.807)",
    stroke: "url(#paint1_linear_1659_35)",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.5 361.002L495 4.50195",
    stroke: "url(#paint2_linear_1659_35)",
    strokeWidth: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82 424.002L4 499.002",
    stroke: "url(#paint3_linear_1659_35)",
    strokeWidth: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1659_35",
    x1: 94.5,
    y1: 16.002,
    x2: 94.5,
    y2: 241.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0499999,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482292,
    stopColor: "#119455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961458,
    stopColor: "#004D03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1659_35",
    x1: 61,
    y1: 257.807,
    x2: 61,
    y2: 314.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961458,
    stopColor: "#132B1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1659_35",
    x1: 316.75,
    y1: 4.50195,
    x2: 316.75,
    y2: 361.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0499999,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482292,
    stopColor: "#0E7A2D",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961458,
    stopColor: "#00260B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1659_35",
    x1: 43,
    y1: 424.002,
    x2: 43,
    y2: 499.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0499999,
    stopColor: "#456C42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482292,
    stopColor: "#0E7A2D",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961458,
    stopColor: "#004D15"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLinesDark);
export default __webpack_public_path__ + "static/media/greenLinesDark.946af3fda178457a72c7d96719e3541c.svg";
export { ForwardRef as ReactComponent };